import { saveAs } from 'file-saver';
import { mapActions, mapGetters } from 'vuex';
import { KButton, KCard, KInput, KModal } from '@/components';
import BarChartWrapper from '@/components/Charts/BarChartWrapper.vue';
import LineWrapper from '@/components/Charts/LineWrapper.vue';
import DatasetResult from '@/mixins/DatasetResult';
import Analysis from '@/mixins/Analysis';

// request
import { advancedSearch, downloadCsv } from '@/api/dataset';

// helpers
import stringHelpers from '@/utils/string-helpers';
import chartTypeOptions from '@/utils/chart-type-options';
import colors from '@/utils/colors';
import EventBus from '@/utils/event-bus';
import countries from '@/utils/countries';
import GetLatestWithValue from '@/mixins/GetLatestWithValue';

import SaveAsPng from '../Save/SaveAsPng.vue';
import SaveAsPdf from '../Save/SaveAsPdf.vue';
import indicatorList from '@/mixins/IndicatorList';
import { getYear } from '@/views/Search/Save/downloadTemplate';
import axios from 'axios';
import Footer from '../../../components/Footer/Footer.vue';
import { queryAnalysis, queryDataset } from '../../../api/search';
import BarChartComponent from '@/components/Charts/NewBarChart.vue';
import LineChartComponent from '@/components/Charts/NewLineChart.vue';

delete countries[''];

export default {
  name: 'SingleResult',
  mixins: [DatasetResult, Analysis, GetLatestWithValue, indicatorList],
  head: {
    title() {
      return { inner: `${this.titleCase(this.country)}: ${this.indicator} on Klevaar` };
    },
  },
  components: {
    SaveAsPng,
    KCard,
    KModal,
    LineWrapper,
    BarChartWrapper,
    KInput,
    KButton,
    SaveAsPdf,
    Footer,
    BarChartComponent,
    LineChartComponent,
  },
  data: () => ({
    notFound: false,
    saving: '',
    isSavingCsv: false,
    showDownloadModal: false,
    showEmbedModal: false,
    showShareModal: false,
    shareLink: '',
    show: true,
    isLoading: true,
    country: '',
    indicator: '',
    userQuestion: '',
    category: 'finance',
    category2: '',
    country2: '',
    frequency: '',
    dataset: {
      chartType: 'line',
      colour: '#900F7B',
      frequency: 'yearly',
      startYear: '1960',
      endYear: '2008',
      values: null,
      metric: '',
      notes: '',
      source: '',
      image: null,
    },
    dataset2: {
      category: '',
      indicator: '',
      starYear: '',
      endYear: '',
      country: '',
    },
    compoundData: null,
    mobileOptions: {},
    customize: false,
    readyCompare: false,
    chartTypeOptions,
    years: {},
    countries,
    colourOptions: colors,
    embedWidth: 950,
    embedHeight: 450,
    showModal: false,
    isCountry: false,
    isIndicator: false,
    isShowCategories: false,
    allCountries: [],
    allCategories: [
      'Agriculture',
      'Economy',
      'Education',
      'Health',
      'Infrastructure',
      'Labour',
      'Monetary',
      'Price',
      'Population',
      'Tax',
      'Tourism',
      'Trade',
    ],
    allCategoriesIndex: 0,
    allIndicators: [],
    categoryIndicators: [],
    isIndicatorLoading: false,
    search: '',
    selectedCountry: '',
    queryDataFetchResult: {},
    fullQueryResult: {},
    chartColor: [
      { name: 'Purple', color: '#900F7B' },
      { name: 'Orange', color: '#FFA500' },
      { name: 'Yellow', color: '#FFFF00' },
      { name: 'Green', color: '#008000' },
      { name: 'Cyan', color: '#00FFFF' },
      { name: 'Blue', color: '#0000FF' },
      { name: 'Pink', color: '#FFC0CB' },
      { name: 'Magenta', color: '#FF00FF' },
    ],
    chartToggleDefault: {
      chartType: 'line',
      color: '#900F7B',
      frequency: 'yearly',
      startYear: null,
      endYear: null,
    },
    apiStartYear: null, // this is the start year from the api
    apiEndYear: null,   // this is the end year from the api
    defaultPeriod: [],
    selectedPeriod: '',
    formLoading: false,
    searchTermChartLabel: '',
    analysisLoading: true,
    analysis_payload: {},
    // chartOptions: {
    //   responsive: true,
    //   maintainAspectRatio: true,
    //   scales: {
    //     x: {
    //       title: {
    //         display: true,
    //         text: 'Time',
    //       },
    //     },
    //     y: {
    //       title: {
    //         display: true,
    //         text: 'Values',
    //       },
    //     },
    //   },
    // },
  }),
  mounted() {
    this.fetchQueryResults();
  },
  async created() {
    const {
      removeSymbols: clean,
      $route: { params, query },
    } = this;
    try {
      const { indicator, country } = params;
      const { category } = query;
      // const id = params.id || query.id;
      // set page heading
      this.indicator = indicator;
      this.country = country;
      // await this.fetchDataset(id, { first: true });
      const {
        data: { data },
      } = await advancedSearch({
        indicator: clean(indicator),
        country: clean(country),
        category: clean(category),
      });

      this.getCountries();

      console.log(data);

      const response = await this.fetchIndicators({
        country: this.country,
      });
      // console.log('This is from countries Indicator', response);

      const promise1 = Promise.resolve(response);
      promise1.then((data) => {
        // console.log('Resolved promise data', data);
        this.allIndicators = data;
        // console.log(this.allIndicators);
      });

      if (data.dataset.length) {
        const compoundData = {};
        data.dataset.forEach((d) => {
          const indicatorMatch = indicator.toLowerCase() === d.nameOfIndicator.toLowerCase();
          const countryMatch = country.toLowerCase() === d.country.toLowerCase();
          const { isPublished } = d;
          if (indicatorMatch && countryMatch && isPublished) {
            compoundData[d.frequency] = {
              ...d,
              endYear: getYear(this.periodWithValue(d.data, d.data.length).period, d.endYear),
            };
          }
        });

        const availableFrequencies = Object.keys(compoundData);
        if (!availableFrequencies.length) {
          // this.notFound = true;
        } else {
          this.compoundData = compoundData;
          this.frequency = query.frequency || Object.keys(compoundData)[0];
        }
        this.isLoading = false;
      } else {
        // this.notFound = true;
      }
      await this.getDatasetOptionsFromURl();
      this.shareLink = window.location.href;
    } catch (e) {
      console.log(e.message);
    }
  },
  watch: {
    frequency(val) {
      const {
        $route: { query },
      } = this;
      const fromCompound = this.compoundData[val];
      const { startYear, endYear } = fromCompound;
      const firstPeriodWithValue =
        query.startYear || this.startPeriodWithValue(fromCompound.data, 0, startYear).period;
      const lastPeriodWithValue =
        query.endYear ||
        this.periodWithValue(fromCompound.data, fromCompound.data.length, endYear).period;
      const yearsArray = fromCompound.data.map((item) => getYear(item.period));
      this.dataset = {
        ...this.dataset,
        ...fromCompound,
        colour: query.colour || this.dataset.colour,
        indicator: this.indicator,
        yearsArray,
        startYear: getYear(firstPeriodWithValue),
        endYear: getYear(lastPeriodWithValue),
        chartType: query.chartType || this.dataset.chartType,
      };
    },
    $route() {
      this.shareLink = window.location.href;
    },
    dataset: {
      deep: true,
      handler(val) {
        this.mobileOptions = { ...val };
        this.updateURLSearchParams(val);
        // this.analysis = val.values ? this.getAnalysis(val) : this.analysis;
        this.show = false;
      },
    },
    show(val) {
      if (!val) {
        setTimeout(this.setShow, 0);
      }
    },
    selectedCountry(value) {
      this.isIndicatorLoading = true;
      const response = this.fetchIndicators({
        country: value.toLowerCase(),
      });
      // console.log('This is from countries Indicator', response);

      const promise1 = Promise.resolve(response);
      promise1.then((data) => {
        // console.log('Resolved promise data', data);
        this.allIndicators = data;
        // console.log(this.allIndicators);
        if (this.allIndicators.length) {
          this.allCategoriesIndex = 0;
          this.isIndicatorLoading = false;
        }
      });
    },

    // watching for changes in the selected  period
    // watch: {
    //   selectedPeriod(newVal) {
    //     console.log('Selected Period changed:', newVal);
    //   },
    //   fullQueryResult(newVal) {
    //     console.log('Full Query Result changed:', newVal);
    //   },
    // },

    // watch for changes in the allYears array update the start and end year
    allYears(newYears) {
      if (Array.isArray(newYears) && newYears.length) {
        const minYear = Math.min(...newYears);
        const maxYear = Math.max(...newYears);

        this.chartToggleDefault.startYear = newYears.includes(this.apiStartYear)
          ? this.apiStartYear
          : minYear;

        this.chartToggleDefault.endYear = newYears.includes(this.apiEndYear)
          ? this.apiEndYear
          : maxYear;
      }
    },
  },
  computed: {
    ...mapGetters({
      categories: 'indicators/categoryOptions',
      indicators: 'indicators/asOptions',
      isAuthenticated: 'auth/getToken',
    }),
    latest() {
      return this.periodWithValue(this.dataset.values.yearly, this.dataset.values.yearly.length);
    },
    compareDataQuery() {
      const {
        dataset: { colour, indicator, category, country, startYear, endYear, frequency, chartType },
        dataset2,
      } = this;

      const query = new URLSearchParams();
      // query.append('id', id);
      query.append('colour', colour);
      query.append('startYear', startYear);
      query.append('endYear', endYear);
      query.append('indicator', indicator);
      query.append('category', category);
      query.append('country', country);
      query.append('frequency', frequency);
      query.append('chartType', chartType);

      Object.entries(dataset2).forEach(([key, value]) => {
        query.append(`${key}2`, value);
      });
      query.append('colour2', '#0F2B90');

      return query.toString();
    },
    embedString() {
      const {
        dataset: { country, indicator, startYear, endYear, colour, frequency, chartType },
        embedWidth,
        embedHeight,
      } = this;
      const { origin } = window.location;
      const query = new URLSearchParams();
      query.append('country', country);
      query.append('indicator', indicator);
      query.append('startYear', startYear);
      query.append('endYear', endYear);
      query.append('colour', colour);
      query.append('frequency', frequency);
      query.append('chartType', chartType);

      const url = `${origin}/chart?${query.toString()}`;
      return `<iframe src='${url}' style='border:0px #ffffff none;' name='Klevaar Embed' scrolling='no' frameBorder='1'marginHeight='0px' marginWidth='0px' height='${embedHeight}px' width='${embedWidth}px' allowFullScreen></iframe>`;
    },
    filteredCountries: function () {
      return this.allCountries.filter(
        (country) =>
          // eslint-disable-next-line
          country.name.common.trim().toLowerCase().match(this.search.trim().toLowerCase())
        // eslint-disable-next-line
      );
    },

    // new logic
    // Extracts values and labels based on selectedPeriod
    queryChatDataSet() {
      const { dataset } = this.fullQueryResult;
      const data = dataset?.[this.selectedPeriod];

      if (!this.selectedPeriod || !Array.isArray(data)) {
        return { values: [], labels: [] };
      }

      const filtered = data.filter((item) => {
        // Extract the year portion from the time string
        const year = parseInt(item.time.match(/\d{4}$/)?.[0], 10);
        return (
          !isNaN(year) &&
          year >= +this.chartToggleDefault.startYear &&
          year <= +this.chartToggleDefault.endYear
        );
      });

      return {
        values: filtered.map((item) => item.value),
        labels: filtered.map((item) => item.time),
      };
    },

    chartData() {
      if (!this.queryChatDataSet.values.length) {
        return { labels: [], datasets: [] };
      }

      const backgroundOpacity = this.chartToggleDefault.color + '20';

      return {
        labels: this.queryChatDataSet.labels,
        datasets: [
          {
            label: this.indicator,
            data: this.queryChatDataSet.values,
            backgroundColor: backgroundOpacity,
            borderColor: this.chartToggleDefault.color,
            borderWidth: 1.5,
          },
        ],
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString:
                  'Values' +
                  ' (in ' +
                  this.fullQueryResult.dataset.metadata.unit[this.selectedPeriod].toLowerCase() +
                  ')',
              },
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Time',
              },
            },
          ],
        },
      };
    },

    // Unique sorted years from the data
    allYears() {
      const dataset = this.fullQueryResult.dataset?.[this.selectedPeriod] || [];
      const validYears = dataset
        .map((d) => {
          // Extract the year portion from the time string
          const year = d.time.match(/\d{4}$/)?.[0]; // Extracts the last four digits (e.g., "2010")
          return parseInt(year, 10); // Converts the year to a number
        })
        .filter((v) => !isNaN(v)); // Filters out invalid years

      return [...new Set(validYears)].sort((a, b) => a - b); // Removes duplicates and sorts the years
    },

    startYearOptions() {
      return this.allYears;
    },

    endYearOptions() {
      return this.allYears.filter((year) => year >= +this.chartToggleDefault.startYear);
    },

    // turn part of analysis to bold
    formattedAnalysis() {
      const raw = this.analysis_payload[this.selectedPeriod]?.analysis || '';
      // Replace **text** with <strong>text</strong>
      return raw.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    },
  },
  methods: {
    ...stringHelpers,
    ...mapActions({
      fetchIndicators: 'indicators/fetchIndicatorsWith',
    }),
    updateDataset() {
      this.dataset = { ...this.dataset, ...this.mobileOptions };
      this.frequency = this.mobileOptions.frequency;
      this.customize = false;
    },
    follow({ clientX: x, clientY: y }) {
      const { definition } = this.$refs;
      definition.style.top = `${y}px`;
      definition.style.left = `${x}px`;
    },
    generate() {
      const canvas = document.querySelector('canvas');
      this.dataset.image = canvas.toDataURL();
    },
    saveAsPng() {
      this.showDownloadModal = false;
      this.saving = 'png';
    },
    saveAsPdf() {
      this.showDownloadModal = false;
      this.saving = 'pdf';
    },
    async saveAsCsv() {
      const { dataset } = this;
      const { id, indicator, country, currency, metric } = dataset;
      this.isSavingCsv = true;
      try {
        const response = await downloadCsv({ id });
        if (response.error) {
          throw Error(response.error);
        }
        const data = response.data.replace(
          'value',
          `value (in ${metric}${currency ? ` ${currency}` : ''})`
        );
        const download = new Blob([data], { type: 'text/plain;charset=UTF-8' });
        const fileName = this.titleCase(`${country} ${this.removeSymbols(indicator)}.csv`);
        saveAs(download, fileName);
        this.$toast.show({ message: ` Downloaded ${fileName}` });
        this.isSavingCsv = false;
        this.showDownloadModal = false;
      } catch (error) {
        console.log(error);
        this.isSavingCsv = false;
      }
    },
    cancelSaving() {
      this.saving = false;
    },
    setShow() {
      this.show = true;
    },
    checkAuthBefore(func) {
      this.isLoggedIn()
        .then(() => {
          func();
        })
        .catch(() => {
          EventBus.$emit('showAuthPrompt');
        });
    },
    getCountries() {
      axios
        .get(`https://restcountries.com/v3.1/all`)
        .then((response) => {
          response.data.sort((a, b) => {
            if (a.name.common < b.name.common) {
              return -1;
            }
            if (a.name.common > b.name.common) {
              return 1;
            }
            return 0;
          });
          this.allCountries = response.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    ...mapActions({
      fetchIndicators: 'indicators/fetchIndicatorsWith',
    }),
    setCategory(index = 0) {
      this.categoryIndicators = this.allIndicators.filter(
        (item) => item.category === this.allCategories[index].toLowerCase()
      );
      this.categoryIndicators.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
    },
    // selectCountry(arrOfObjects, obj) {
    //   let cArray = [];
    //   return arrOfObjects.filter(function (item) {
    //     for (let key in obj) {
    //       if (item.name.common != obj[key]) {
    //         cArray.push(item);
    //         return cArray;
    //       }
    //     }
    //   });
    // },

    updateFrequency(option) {
      this.selectedPeriod = option.toLowerCase();
    },

    updateChatType(option) {
      this.chartToggleDefault.chartType = option;
    },

    updatePeriod(option) {
      this.chartToggleDefault.chartType = option;
    },

    async fetchQueryResults() {
      this.isLoading = true;
      
      try {
        const response = await queryDataset({ q: this.$route.params.indicator });
        if (response.data.is_data) {
          const dataset = response.data.dataset;
          await this.fetchAnalysis(response.data.analysis_payload);

          this.indicator = response.data.analysis_payload.title;
          this.userQuestion = response.data.analysis_payload.user_query;

          // Check for valid periods and set selectedPeriod
          this.defaultPeriod = Object.keys(dataset).filter(
            (key) => ['monthly', 'quarterly', 'yearly'].includes(key) && dataset[key]?.length
          );

          // Set selectedPeriod from the first valid period in defaultPeriod
          this.selectedPeriod = this.defaultPeriod.length ? this.defaultPeriod[0] : '';
          this.frequency = this.selectedPeriod;

          // Ensure that fullQueryResult is set
          this.fullQueryResult = response.data;
          console.log('Full Query Result:', this.fullQueryResult);

          // Store the API years for later use
          this.apiStartYear = parseInt(response.data.start_date?.match(/\d{4}/)?.[0], 10);
          this.apiEndYear = parseInt(response.data.end_date?.match(/\d{4}/)?.[0], 10);
          

          this.isLoading = false;
        } else {
          this.notFound = true;
        }
      } catch (error) {
        this.isLoading = false;
        this.notFound = true;
        this.$toast.show({ message: 'Something unexpected occurred on the server' });
      } finally {
        this.isLoading = false;
      }
    },

    async fetchAnalysis(query_payload) {
      this.analysisLoading = true;
      try {
        const response = await queryAnalysis(query_payload);
        if (response.data.is_data) {
          this.analysisLoading = false;
          this.analysis_payload = response.data.dataset;
        }
      } catch (error) {
        this.$toast.show({ message: 'Something unexpected occurred when querying analysis.' });
        this.analysisLoading = false;
      } finally {
        this.analysisLoading = false;
      }
    },

    async goToSearch(value = '') {
      const searchTerm = value.trim() || this.search.trim();
      this.search = ''; // Clear the search input

      if (searchTerm) {
        this.formLoading = true;
        try {
          const response = await queryDataset({ q: searchTerm });
          // if the search returns a valid result, navigate to the singleresults page
          this.searchTermChartLabel = searchTerm;
          if (response.data.is_data) {
            this.formLoading = false;
            await this.fetchAnalysis(response.data.analysis_payload);
            // this.$router.push({ name: 'SingleResult', query: { q: encodeURIComponent(searchTerm) } });
            const r = response.data.related_search[0];
            const path = `/indicators/${encodeURIComponent(r.search)}/${encodeURIComponent(
              r.metadata.country
            )}`;
            const query = {
              category: r.metadata.category,
              frequency: r.metadata.frequency,
              chartType: 'line',
              colour: '#23900F7B',
              startYear: r.metadata.min_date,
              endYear: r.metadata.max_date,
              country: r.metadata.country,
              indicator: r.metadata.indicator,
            };

            // updating the computed values
            const dataset = response.data.dataset;
            this.indicator = response.data.analysis_payload.title;
            this.userQuestion = response.data.analysis_payload.user_query;

            // Check for valid periods and set selectedPeriod
            this.defaultPeriod = Object.keys(dataset).filter(
              (key) => ['monthly', 'quarterly', 'yearly'].includes(key) && dataset[key]?.length
            );

            // Set selectedPeriod from the first valid period in defaultPeriod
            this.selectedPeriod = this.defaultPeriod.length ? this.defaultPeriod[0] : '';
            this.frequency = this.selectedPeriod;

            // Ensure that fullQueryResult is set
            this.fullQueryResult = response.data;

            // Store the API years for later use
            this.apiStartYear = parseInt(response.data.start_date?.match(/\d{4}/)?.[0], 10);
            this.apiEndYear = parseInt(response.data.end_date?.match(/\d{4}/)?.[0], 10);

            this.$router.push({ path, query });
          } else {
            this.formLoading = false;
            this.$router.push({ name: 'Results', query: { q: encodeURIComponent(searchTerm) } });
          }
        } catch (error) {
          this.$toast.show({
            message: 'Something unexpected occurred on the server',
          });
          this.formLoading = false;
        } finally {
          this.formLoading = false;
        }
      }
    },
  },
};
